import React, { Component } from 'react';
import { connect } from 'react-redux';
import DiscountSave from './DiscountSave';
import DiscountList from './DiscountList';
import { showError } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';

class DiscountPage extends Component {
    constructor(props, context) {
        const discountId = props.params.id;
        super(props, context);
        this.state = {
            status: discountId ? "EDIT" : "LIST"
        };
    }

    componentWillMount() {

    }


    redirectToAddPage() {
        this.props.navigate("/manage/discount/add");
    }

    redirectToListPage() {
        this.props.navigate("/manage/discount");
    }

    render() {
        const discountId = this.props.params.id;
        const isSave = discountId || this.props.location.pathname === "/manage/discount/add";
        return (
            <React.Fragment>
                {
                    isSave ?
                        (<DiscountSave
                            name="discountSave"
                            params={this.props.params} />)
                        : (<DiscountList />)
                }
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (message) => dispatch(showError(message))
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DiscountPage));